import type { SchemaBuilderConditionFieldOperatorProps } from "./schema-builder-condition-field-operator.type";
import type { SchemaOperator } from "@/entities/schema";

import { Form, Select } from "antd";
import { useTranslation } from "react-i18next";

import { SCHEMA_OPERATORS } from "@/entities/schema";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

export const SchemaBuilderConditionFieldOperator = ({
  field,
  onChange,
}: SchemaBuilderConditionFieldOperatorProps) => {
  const { t } = useTranslation();

  const placeholder = t("schema:conditions.operator.placeholder");
  const missingMessage = t("schema:conditions.operator.missing");

  const onOperatorChange = (value: SchemaOperator) => {
    onChange?.(value);
  };

  return (
    <Form.Item
      name={[field.name, "operator"]}
      rules={[{ required: true, message: missingMessage }]}
      className="schema-builder-condition-field-operator"
    >
      <Select
        onChange={onOperatorChange}
        placeholder={placeholder}
        aria-label={placeholder}
      >
        {SCHEMA_OPERATORS.map((operator) => (
          <Option key={operator} value={operator}>
            {operator}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};
